import colors from "assets/scss/colors.scss";

//sizes needed
const headerHeightMd = "60px";
const headerHeightXs = "30px";
const footerHeight = "40px";
const bodyHeightSm = `calc(100vh - 109px)`;

//Header
export const headerGridContainer = {
  height: headerHeightMd, //
  boxShadow: "0px 0px 2px 2px gray",
  zIndex: 2,
};

export function headerGridItem() {
  return {
    padding: 0,
    margin: 0,
    maxHeight: { xs: headerHeightXs, md: headerHeightMd },
    height: { xs: headerHeightXs, md: headerHeightMd },
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    bgcolor: colors.headerBackground,
    alignItems: "center",
  };
}

//Body
export function contentGridItem() {
  return {
    overflowY: "auto",
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    maxHeight: { xs: "auto", sm: bodyHeightSm },
    height: { xs: "auto", sm: bodyHeightSm },
    margin: 0,
    padding: 0,
    // border: "solid",
  };
}

export function bodyGridContainer() {
  return {
    maxHeight: { xs: "auto", sm: bodyHeightSm },

    height: { xs: "auto", sm: bodyHeightSm },
    marginTop: "4px",
  };
}

export function leftMenuGridItem() {
  return {
    overflowY: "auto",
    minHeight: { xs: "auto", sm: bodyHeightSm },
    height: { xs: "auto", sm: bodyHeightSm },
    zIndex: 1,
    bgcolor: colors.footerBackground,
    borderRadius: 1,
  };
}

export function boxLeftMenu() {
  return {
    overflowY: "auto",
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    maxHeight: { xs: "auto", md: bodyHeightSm },
    height: { xs: "auto", md: bodyHeightSm },
    margin: 0,
    // border: "solid",
  };
}

//Footer
export const footerGridItem = {
  height: footerHeight,
  boxShadow: "0px -2px 2px 0px gray",
  bgcolor: colors.footerBackground,
  zIndex: 2,
  marginTop: "4px",
};
